import { secondaryFilledButtonProps } from "@canucci/base-mantine/theme";
import { Button } from "@mantine/core";
import { useFullscreen } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { RiFullscreenExitLine, RiFullscreenLine } from "react-icons/ri";

export function FullscreenButton() {
  const { t } = useTranslation("pages");
  const { fullscreen, toggle } = useFullscreen();
  const label = fullscreen ? t("fullscreen.exit") : t("fullscreen.enter");
  const visibleLabel = t("fullscreen.label");

  const handleToggle = async () => {
    try {
      await toggle();
    } catch {
      // Browsers can reject fullscreen when it is unsupported or disallowed.
    }
  };

  return (
    <Button
      {...secondaryFilledButtonProps}
      leftSection={fullscreen ? <RiFullscreenExitLine size="1rem" /> : <RiFullscreenLine size="1rem" />}
      aria-label={label}
      onClick={handleToggle}
    >
      {visibleLabel}
    </Button>
  );
}
